import { useMemo } from 'react';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { useCurrentUser } from '@/hooks/useCurrentUser';

import { Permissions } from '@/constants';

import { MemberList } from '../Members/MembersListPage/MembersListPage';
import { RoleListPage } from '../Roles/RoleListPage/RoleListPage';

export default function Settings() {
  const { userData } = useCurrentUser();

  const defaultTab = useMemo<'members' | 'roles'>(() => {
    const permissions = userData.permissions || [];
    if (permissions.includes(Permissions.UsersRead)) return 'members';
    if (permissions.includes(Permissions.RolesRead)) return 'roles';
    return 'members';
  }, [userData.permissions]);

  return (
    <div className="mx-auto flex max-w-6xl flex-col space-y-4 p-4 pb-8 sm:space-y-4 sm:p-6 sm:pb-12">
      <Tabs key={defaultTab} defaultValue={defaultTab} className="w-full gap-4">
        <TabsList className="text-foreground h-auto gap-2 rounded-none border-b bg-transparent px-0 py-1 w-full justify-start">
          <ProtectedComponent requiredPermissions={[Permissions.UsersRead]}>
            <TabsTrigger
              value="members"
              className="hover:bg-primary/10 hover:text-primary data-[state=active]:after:bg-primary data-[state=active]:hover:bg-primary/10 relative after:absolute after:inset-x-0 after:bottom-0 after:-mb-1.5 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Members
            </TabsTrigger>
          </ProtectedComponent>
          <ProtectedComponent requiredPermissions={[Permissions.RolesRead]}>
            <TabsTrigger
              value="roles"
              className="hover:bg-primary/10 hover:text-primary data-[state=active]:after:bg-primary data-[state=active]:hover:bg-primary/10 relative after:absolute after:inset-x-0 after:bottom-0 after:-mb-1.5 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Roles
            </TabsTrigger>
          </ProtectedComponent>
        </TabsList>

        <ProtectedComponent requiredPermissions={[Permissions.UsersRead]}>
          <TabsContent value="members">
            <MemberList />
          </TabsContent>
        </ProtectedComponent>

        <ProtectedComponent requiredPermissions={[Permissions.RolesRead]}>
          <TabsContent value="roles">
            <RoleListPage />
          </TabsContent>
        </ProtectedComponent>
      </Tabs>
    </div>
  );
}
